import { useEffect, useState } from "react";

const ErrorValidate = ({ error }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Trigger the fade-in effect after the component is mounted
    const timer = setTimeout(() => setIsVisible(true), 300); // Small delay for smooth effect
    return () => clearTimeout(timer); // Cleanup timer on unmount
  }, []);
  return (
    <>
      <div
        className={`mx-5 flex items-center justify-center p-4 mb-4 text-sm text-red-800 border border-red-300 rounded-lg bg-red-50 ${
          isVisible ? "opacity-1" : "opacity-0"
        }`}
        role="alert"
      >
        <svg
          className="flex-shrink-0 inline w-4 h-4 mr-1"
          aria-hidden="true"
          xmlns="http://www.w3.org/2000/svg"
          fill="currentColor"
          viewBox="0 0 20 20"
        >
          <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5ZM9.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM12 15H8a1 1 0 0 1 0-2h1v-3H8a1 1 0 0 1 0-2h2a1 1 0 0 1 1 1v4h1a1 1 0 0 1 0 2Z" />
        </svg>
        <span className="sr-only">Info</span>
        <div>
          <span className="font-medium">{error}</span>
        </div>
      </div>
    </>
  );
};

export default ErrorValidate;
